export default function validateURL(text?: string): boolean | string {
  try {
    return Boolean(new URL(text))
  } catch (error) {
    return 'The value entered is not a valid URL'
  }
}